import { api } from "@/api";
import { sleep } from "@/shared/utils";

export type SystemConfigurationUpsert = {
  key: string;
  type: "String" | "Number" | "Boolean";
  stringValue: string;
};

export async function setSystemConfigurations(entries: SystemConfigurationUpsert[], organizacionId?: string): Promise<void> {
  await sleep(1000);
  const params = organizacionId ? { organizacionId } : {};
  await api.put("configuration/params", { entries }, { params });
}